import { memo } from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock, Navigation, ArrowRight } from "lucide-react";

const LOCATIONS = [
  {
    id: "hailey",
    name: "Hailey",
    address: "100 Main Street, Hailey, ID 83333",
    hours: "Mon–Sun · 11am–9pm",
    phone: "(208) 721-3200",
    tag: "Flagship",
    mapQuery: "100+Main+Street+Hailey+ID",
  },
  {
    id: "ketchum",
    name: "Ketchum / Sun Valley",
    address: "Opening soon · Ketchum, ID",
    hours: "Coming Winter 2026",
    phone: "(208) 721-3200",
    tag: "Opening soon",
    mapQuery: "Ketchum+ID",
  },
];

function LocationsTeaser() {
  return (
    <section
      data-testid="home-locations"
      className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16"
    >
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <p className="text-xs uppercase tracking-[0.18em] text-primary/80">Find your shop</p>
          <h2 className="font-brand font-semibold text-[1.9rem] sm:text-3xl lg:text-4xl tracking-tight mt-2">
            Two shops. One obsession.
          </h2>
        </div>
        <Link
          to="/locations"
          className="inline-flex items-center gap-1 text-sm font-semibold text-primary hover:text-primary/80"
          data-testid="home-locations-see-all-link"
        >
          See all locations <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="mt-6 grid gap-4 md:grid-cols-2">
        {LOCATIONS.map((loc) => (
          <div
            key={loc.id}
            data-testid={`home-location-${loc.id}-card`}
            className="bp-card p-5 sm:p-6 flex flex-col gap-4 hover:-translate-y-0.5 transition-transform"
          >
            <div
              aria-hidden="true"
              className="relative rounded-xl h-[130px] sm:h-[150px] border border-border/60 overflow-hidden"
              style={{
                background:
                  "radial-gradient(600px circle at 20% 20%, hsla(252,63%,80%,0.25), transparent 55%)," +
                  "radial-gradient(600px circle at 85% 80%, hsla(330,78%,80%,0.25), transparent 60%)," +
                  "linear-gradient(135deg, hsl(260 45% 96%), hsl(330 40% 96%))",
              }}
            >
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-11 h-11 rounded-full bg-primary text-primary-foreground grid place-items-center shadow-lg">
                  <MapPin className="w-5 h-5" />
                </div>
              </div>
            </div>

            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="flex items-center gap-2">
                  <h3 className="font-brand font-semibold text-xl">{loc.name}</h3>
                  <span className="bp-chip bp-chip-new">{loc.tag}</span>
                </div>
                <p className="text-sm text-muted-foreground mt-1">{loc.address}</p>
              </div>
            </div>

            <div className="flex items-center justify-between gap-3 flex-wrap">
              <div className="flex items-center gap-2 text-sm text-muted-foreground tabular-nums">
                <Clock className="w-4 h-4 text-primary/70" /> {loc.hours}
              </div>
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${loc.mapQuery}`}
                target="_blank"
                rel="noreferrer"
                data-testid={`home-location-${loc.id}-directions-button`}
                className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:text-primary/80"
              >
                <Navigation className="w-4 h-4" /> Directions
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default memo(LocationsTeaser);
